<cap-list-loader [hasRight]="hasRight" [listLoader]="listLoader" [showTotal]="false" [showZeilenSelect]="false">
  <div class="cap-list-loader-content">
    <table class="cap-table-detail">
      <tbody>
        <ng-template [ngTemplateOutlet]="tableRowsFlurname"></ng-template>
      </tbody>
    </table>
  </div>
</cap-list-loader>

<ng-template #tableRowsFlurname>
  @if (listLoader?.items) {
    @for (flurname of listLoader?.items; track flurname) {
      <tr>
        <td style="width: 40%">
          {{ flurname.lagebezeichnungsTyp | translate }}
        </td>
        <td style="width: 60%">
          <span [capHistinfo]="flurname.histInfo">
            {{ flurname.adressText }}
          </span>
          <cap-kompakt-timepoint [item]="flurname.histInfo?.bisTimePoint" loeschgeschaeft></cap-kompakt-timepoint>
        </td>
      </tr>
    }
  }
</ng-template>
